export default __webpack_public_path__ + "static/media/at.03af1c56.svg";